import { createReducer } from 'redux-create-reducer';
import callAPI from '../../../utils/callAPI';
import { defaultClueQueryLimit, requiredCoordinates } from '../../../constant/clue';
import callOptionalAuthAPI from '../../../utils/callOptionalAuthAPI';

export const ACTION_REQUEST_CLUES = 'ACTION_REQUEST_CLUES';
export const UPDATE_CLUE_FILTER = 'UPDATE_CLUE_FILTER';
export const REQUEST_CLUES = 'REQUEST_CLUES';
export const REQUEST_CLUES_SUCCESS = 'REQUEST_CLUES_SUCCESS';
export const REQUEST_CLUES_FAILURE = 'REQUEST_CLUES_FAILURE';

export const ACTION_SET_CLUE_DETAIL = 'clue/ACTION_SET_CLUE_DETAIL';
export const REQUEST_TREASURE_DETAIL = 'clue/REQUEST_TREASURE_DETAIL';
export const REQUEST_TREASURE_DETAIL_SUCCESS = 'clue/REQUEST_TREASURE_DETAIL_SUCCESS';
export const REQUEST_TREASURE_DETAIL_FAILURE = 'clue/REQUEST_TREASURE_DETAIL_FAILURE';

export const ACTION_REQUEST_PUT_CLUE = 'clue/ACTION_REQUEST_PUT_CLUE';
export const REQUEST_PUT_CLUE = 'clue/REQUEST_PUT_CLUE';
export const REQUEST_PUT_CLUE_SUCCESS = 'clue/REQUEST_PUT_CLUE_SUCCESS';
export const REQUEST_PUT_CLUE_FAILURE = 'clue/REQUEST_PUT_CLUE_FAILURE';

export const CREATE_CLUE_REQUEST = 'CREATE_CLUE_REQUEST';
export const CREATE_CLUE_SUCCESS = 'CREATE_CLUE_SUCCESS';
export const CREATE_CLUE_FAILURE = 'CREATE_CLUE_FAILURE';

const defaultState = {
  clueFilter: {
    retailerName: '',
    longitude: null,
    latitude: null,
    east: null,
    north: null,
    south: null,
    west: null,
    limit: defaultClueQueryLimit,
  },

  clues: [],
  totalClue: 0,
  fetchingClues: true,
  failedFetchingClues: false,
  requestClueSuccess: false,

  requestingPutClues: true,
  failedRequestingPutClues: false,

  clueDetail: null,
  treasureDetail: null,
  fetchingTreasureDetail: true,
  failedFetchingTreasureDetail: false,

  creatingClue: false,
  failedCreatingClue: false,
};

const reducer = createReducer(defaultState, {
  //get clue
  [UPDATE_CLUE_FILTER]: (state, _action) => ({
    ...state,
    clueFilter: _action.payload,
  }),
  [REQUEST_CLUES]: (state, _action) => ({
    ...state,
    fetchingClues: true,
    failedFetchingClues: false,
  }),
  [REQUEST_CLUES_SUCCESS]: (state, action) => ({
    ...state,
    clues: action.payload?.data?.items,
    totalClue: action.payload?.data?.length,
    fetchingClues: false,
    failedFetchingClues: false,
    requestClueSuccess: true,
  }),
  [REQUEST_CLUES_FAILURE]: (state, _action) => ({
    ...state,
    fetchingClues: false,
    failedFetchingClues: true,
  }),
  [ACTION_SET_CLUE_DETAIL]: (state, action) => ({
    ...state,
    clueDetail: action?.payload,
  }),
  [REQUEST_TREASURE_DETAIL]: (state, _action) => ({
    ...state,
    fetchingTreasureDetail: true,
    failedFetchingTreasureDetail: false,
  }),
  [REQUEST_TREASURE_DETAIL_SUCCESS]: (state, action) => ({
    ...state,
    treasureDetail: action.payload?.data,
    totalClue: action.payload?.data?.length,
    fetchingTreasureDetail: false,
    failedFetchingTreasureDetail: false,
  }),
  [REQUEST_TREASURE_DETAIL_FAILURE]: (state, _action) => ({
    ...state,
    fetchingTreasureDetail: false,
    failedFetchingTreasureDetail: true,
  }),
  [REQUEST_PUT_CLUE]: (state, _action) => ({
    ...state,
    fetchingTreasureDetail: true,
    failedFetchingTreasureDetail: false,
  }),
  [REQUEST_PUT_CLUE_SUCCESS]: (state, action) => ({
    ...state,
    treasureDetail: action.payload?.data,
    totalClue: action.payload?.data?.length,
    fetchingTreasureDetail: false,
    failedFetchingTreasureDetail: false,
  }),
  [REQUEST_PUT_CLUE_FAILURE]: (state, _action) => ({
    ...state,
    fetchingTreasureDetail: false,
    failedFetchingTreasureDetail: true,
  }),

  //create clue
  [CREATE_CLUE_REQUEST]: (state, _action) => ({
    ...state,
    creatingClue: true,
    failedCreatingClue: false,
  }),
  [CREATE_CLUE_SUCCESS]: (state, _action) => ({
    ...state,
    creatingClue: false,
    failedCreatingClue: false,
  }),
  [CREATE_CLUE_FAILURE]: (state, _action) => ({
    ...state,
    creatingClue: false,
    failedCreatingClue: true,
  })
});

export default reducer;
export const namespace = 'clue';

export const actionRequestClues = () => ({
  type: ACTION_REQUEST_CLUES,
});

export const actionSetClueDetail = (clue) => ({
  type: ACTION_SET_CLUE_DETAIL,
  payload: clue,
});

export const actionUpdateClue = (clue) => ({
  type: ACTION_REQUEST_PUT_CLUE,
  payload: clue,
});

export const getCluesAPI = (filter) => async (dispatch, getState) => {
  const hasCoordinates = requiredCoordinates.every((coord) => filter?.[coord] != null);

  if (!hasCoordinates) {
    return;
  }

  return await callOptionalAuthAPI({
    method: 'get',
    apiPath: '/clues',
    actionTypes: [REQUEST_CLUES, REQUEST_CLUES_SUCCESS, REQUEST_CLUES_FAILURE],
    variables: {
      ...filter,
    },
    dispatch,
    getState,
  });
};

export const getTreasureDetailAPI = (id) => async (dispatch, getState) => {
  return await callAPI({
    method: 'get',
    apiPath: `/campaigns/treasures/${id}`,
    actionTypes: [
      REQUEST_TREASURE_DETAIL,
      REQUEST_TREASURE_DETAIL_SUCCESS,
      REQUEST_TREASURE_DETAIL_FAILURE,
    ],
    dispatch,
    getState,
  });
};

export const putClueAPI = (payload) => async (dispatch, getState) => {
  return await callAPI({
    method: 'put',
    apiPath: `/clues/${payload?.id}`,
    actionTypes: [
      REQUEST_PUT_CLUE,
      REQUEST_PUT_CLUE_SUCCESS,
      REQUEST_PUT_CLUE_FAILURE,
    ],
    variables: {
      ...payload,
    },
    dispatch,
    getState,
  });
};
export const actionCreateClue = (payload) => ({
  type: CREATE_CLUE_REQUEST,
  payload,
});

export const createClueAPI = (payload) => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: '/clues',
    actionTypes: [CREATE_CLUE_REQUEST, CREATE_CLUE_SUCCESS, CREATE_CLUE_FAILURE],
    variables: payload,
    dispatch,
    getState,
  });
};